import React from 'react';

import { toISOStringWithTimezone } from '../../../../utils';
import { IPost } from '../../Post';

interface IMicrodata
  extends Pick<IPost, 'dateModified' | 'datePublished' | 'postUrl' | 'postId' | 'title' | 'image' | 'authorLinks'> {
  authorName?: string;
}

/**
 * Микроразметка
 */
export const Microdata = ({
  dateModified,
  datePublished,
  authorName,
  postId,
  postUrl,
  title,
  image,
}: IMicrodata) => {
  return (
    <>
      <meta itemProp="identifier" content={String(postId)} />
      <meta itemProp="inLanguage" content={'ru'} />
      <meta itemProp="image" content={image || undefined} />
      <meta itemProp="name" content={title} />
      <meta itemProp="url" content={`https://www.cian.ru${postUrl}`} />
      <link itemProp="mainEntityOfPage" href={`https://www.cian.ru${postUrl}`} />

      {authorName && (
        <div itemProp="author" itemScope itemType="https://schema.org/Person">
          <meta itemProp="name" content={authorName || 'Циан Журнал'} />
          <meta itemProp="url" content="https://www.cian.ru/magazine/" />
        </div>
      )}

      <div itemProp="publisher" itemScope itemType="https://schema.org/Organization">
        <meta itemProp="name" content="Циан Журнал" />
        <meta itemProp="logo" content={'https://content.cdn-cian.ru/realty/logo-cian.svg'} />
        <meta itemProp="url" content="https://www.cian.ru/magazine/" />
      </div>

      {dateModified && <meta itemProp="dateModified" content={toISOStringWithTimezone(new Date(dateModified))} />}
      <meta itemProp="dateCreated" content={toISOStringWithTimezone(new Date(datePublished))} />
      <meta itemProp="datePublished" content={toISOStringWithTimezone(new Date(datePublished))} />
    </>
  );
};
